// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerRequestAttachment')
class Orders__CustomerRequestAttachment {
    @jsonProperty(() => Orders__CustomerRequestAttachment.Id)
    id: Orders__CustomerRequestAttachment.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "fileName", "mimeType", "redactionBoxes", "request", "requestId", "data", "dataId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "fileName", "mimeType", "redactionBoxes", "request", "requestId", "data", "dataId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "fileName", "mimeType", "redactionBoxes", "request", "requestId", "data", "dataId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "fileName": "string", "mimeType": "string", "redactionBoxes": "any", "request": "Orders.CustomerRequest", "requestId": "Orders.CustomerRequest.Id", "data": "System.BinaryData", "dataId": "System.BinaryData.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ request: () => Orders.CustomerRequest } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({ data: () => System.BinaryData } as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θfileName = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θmimeType = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θredactionBoxes = Signals.proxySignalDeferred<any>(() => (undefined) as any);
    private readonly θrequest = Signals.proxySignalDeferred<Orders.CustomerRequest>(() => (undefined) as any);
    private readonly θrequestId = Signals.proxySignalDeferred<Orders.CustomerRequest.Id>(() => (undefined) as any);
    private readonly θdata = Signals.proxySignalDeferred<System.BinaryData>(() => (undefined) as any);
    private readonly θdataId = Signals.proxySignalDeferred<System.BinaryData.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerRequestAttachment' {
        return 'Orders.CustomerRequestAttachment'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerRequestAttachment' {
        return 'Orders.CustomerRequestAttachment'
    }

    static get __baseType(): 'Orders.CustomerRequestAttachment' {
        return 'Orders.CustomerRequestAttachment'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerRequestAttachment' {
        return 'Orders.CustomerRequestAttachment'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerRequestAttachment[BoInfoSymbol]
    }

    get fileName(): string {
        return this.θfileName?.()
    }

    set fileName(fileName) {
        this.θfileName.set(coerceDataType(fileName, 'string', false, true))
    }

    get mimeType(): string {
        return this.θmimeType?.()
    }

    set mimeType(mimeType) {
        this.θmimeType.set(coerceDataType(mimeType, 'string', false, true))
    }

    get redactionBoxes(): any {
        return this.θredactionBoxes?.()
    }

    set redactionBoxes(redactionBoxes) {
        this.θredactionBoxes.set(coerceDataType(redactionBoxes, 'any', false, true))
    }

    get request(): Orders.CustomerRequest {
        return this.θrequest?.()
    }

    set request(request) {
        this.θrequest.set(coerceDataType(request, Orders.CustomerRequest, false, true))
        if (request) {
            this.θrequestId.set(request.id)
        } else if (request === null && request) {
            this.θrequestId.set(null)
        }
    }

    get requestId(): Orders.CustomerRequest.Id {
        return this.θrequestId?.()
    }

    set requestId(requestId) {
        if (requestId === null) this.θrequest.set(null)
        if (this.request?.id && requestId != this.request.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestId.set(coerceDataType(requestId, 'Orders.CustomerRequest.Id', false, true))
    }

    get data(): System.BinaryData {
        return this.θdata?.()
    }

    set data(data) {
        this.θdata.set(coerceDataType(data, System.BinaryData, false, true))
        if (data) {
            this.θdataId.set(data.id)
        } else if (data === null && data) {
            this.θdataId.set(null)
        }
    }

    get dataId(): System.BinaryData.Id {
        return this.θdataId?.()
    }

    set dataId(dataId) {
        if (dataId === null) this.θdata.set(null)
        if (this.data?.id && dataId != this.data.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θdataId.set(coerceDataType(dataId, 'System.BinaryData.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerRequestAttachment>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerRequestAttachment()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerRequestAttachment>, restrictToClass?: Class<Partial<Orders__CustomerRequestAttachment>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('fileName', 'mimeType', 'redactionBoxes', 'request', 'requestId', 'data', 'dataId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerRequestAttachment {
        return equal(this, other)
    }
}

namespace Orders__CustomerRequestAttachment { }

export import CustomerRequestAttachment = Orders__CustomerRequestAttachment
setTimeout(() => {
    jsonProperty(() => String)(Orders__CustomerRequestAttachment.prototype, 'fileName')
    jsonProperty(() => String)(Orders__CustomerRequestAttachment.prototype, 'mimeType')
    jsonProperty(() => AnyType)(Orders__CustomerRequestAttachment.prototype, 'redactionBoxes')
    jsonProperty(() => Orders.CustomerRequest)(Orders__CustomerRequestAttachment.prototype, 'request')
    jsonProperty(() => Orders.CustomerRequest.Id)(Orders__CustomerRequestAttachment.prototype, 'requestId')
    jsonProperty(() => System.BinaryData)(Orders__CustomerRequestAttachment.prototype, 'data')
    jsonProperty(() => System.BinaryData.Id)(Orders__CustomerRequestAttachment.prototype, 'dataId')
    jsonProperty(() => Date)(Orders__CustomerRequestAttachment.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestAttachment.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerRequestAttachment.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestAttachment.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerRequestAttachment.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestAttachment.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerRequestAttachment.prototype, 'versionNumber')
})

export const CustomerRequestAttachmentθId = Number;

export type CustomerRequestAttachmentθId = number;

namespace Orders__CustomerRequestAttachment {
    export type Id = NominalType<number, 'Orders.CustomerRequestAttachment'>

}
